// source: pbtypes/gen/structure/frame.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_skills_gps_waypoint_pb = require('../../../pbtypes/gen/skills/gps_waypoint_pb.js');
goog.object.extend(proto, pbtypes_gen_skills_gps_waypoint_pb);
var pbtypes_gen_skills_waypoint_frame_type_pb = require('../../../pbtypes/gen/skills/waypoint_frame_type_pb.js');
goog.object.extend(proto, pbtypes_gen_skills_waypoint_frame_type_pb);
goog.exportSymbol('proto.structure.Frame', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.structure.Frame = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.structure.Frame, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.structure.Frame.displayName = 'proto.structure.Frame';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.structure.Frame.prototype.toObject = function(opt_includeInstance) {
  return proto.structure.Frame.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.structure.Frame} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.structure.Frame.toObject = function(includeInstance, msg) {
  var f, obj = {
type: jspb.Message.getFieldWithDefault(msg, 1, 0),
gpsOrigin: (f = msg.getGpsOrigin()) && pbtypes_gen_skills_gps_waypoint_pb.GpsWaypoint.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.structure.Frame}
 */
proto.structure.Frame.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.structure.Frame;
  return proto.structure.Frame.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.structure.Frame} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.structure.Frame}
 */
proto.structure.Frame.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.skills.WaypointFrameType.Enum} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var value = new pbtypes_gen_skills_gps_waypoint_pb.GpsWaypoint;
      reader.readMessage(value,pbtypes_gen_skills_gps_waypoint_pb.GpsWaypoint.deserializeBinaryFromReader);
      msg.setGpsOrigin(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.structure.Frame.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.structure.Frame.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.structure.Frame} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.structure.Frame.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getGpsOrigin();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      pbtypes_gen_skills_gps_waypoint_pb.GpsWaypoint.serializeBinaryToWriter
    );
  }
};


/**
 * optional skills.WaypointFrameType.Enum type = 1;
 * @return {!proto.skills.WaypointFrameType.Enum}
 */
proto.structure.Frame.prototype.getType = function() {
  return /** @type {!proto.skills.WaypointFrameType.Enum} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.skills.WaypointFrameType.Enum} value
 * @return {!proto.structure.Frame} returns this
 */
proto.structure.Frame.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional skills.GpsWaypoint gps_origin = 2;
 * @return {?proto.skills.GpsWaypoint}
 */
proto.structure.Frame.prototype.getGpsOrigin = function() {
  return /** @type{?proto.skills.GpsWaypoint} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_skills_gps_waypoint_pb.GpsWaypoint, 2));
};


/**
 * @param {?proto.skills.GpsWaypoint|undefined} value
 * @return {!proto.structure.Frame} returns this
*/
proto.structure.Frame.prototype.setGpsOrigin = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.structure.Frame} returns this
 */
proto.structure.Frame.prototype.clearGpsOrigin = function() {
  return this.setGpsOrigin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.structure.Frame.prototype.hasGpsOrigin = function() {
  return jspb.Message.getField(this, 2) != null;
};


goog.object.extend(exports, proto.structure);
